import React from "react"
import { Box, Typography } from "@mui/material"

const LABEL_SX = { fontSize: 11, color: "#6b7280", flex: "none" }
const VALUE_SX = { fontSize: 11, color: "#004f7d", fontWeight: 600, textAlign: "right", overflowWrap: "anywhere" }

// Rows [label, value]; a row without label renders as bold heading line.
export default function FeatureCardBody({ rows = [], text = null, footer = null }) {
  const shown = rows.filter((row) => row && row[1] != null && row[1] !== "")
  return (
    <Box sx={{ px: 1.25, py: 1 }}>
      {shown.map(([label, value], i) =>
        label ? (
          <Box key={i} sx={{ display: "flex", justifyContent: "space-between", gap: 1.5, mb: 0.35 }}>
            <Typography sx={LABEL_SX}>{label}</Typography>
            <Typography sx={VALUE_SX}>{String(value)}</Typography>
          </Box>
        ) : (
          <Typography key={i} sx={{ fontSize: 13, fontWeight: 700, color: "#004f7d", mb: 0.5 }}>
            {String(value)}
          </Typography>
        ),
      )}
      {text && (
        <Typography sx={{ fontSize: 12, color: "#004f7d", lineHeight: 1.4, mt: shown.length ? 0.75 : 0, whiteSpace: "pre-line" }}>
          {text}
        </Typography>
      )}
      {footer && <Box sx={{ mt: 1 }}>{footer}</Box>}
    </Box>
  )
}
